// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1glJR","col":"styles_col__1pjLK","actions":"styles_actions__1xbSd","conflict":"styles_conflict__3fzAk"};